import { OnboardingLayout } from "Components/Layout/OnboardingLayout";
import { NewUserRoleSelection } from "Components/Onboarding/SSO/NewUserRoleSelection";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { UserStatus } from "Infrastructure/Api/Api";
import { Navigate } from "Navigation/Navigate";
import { appUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Auth.SSO.CompleteSSORegistration;

export const CompleteSSORegistrationPage = () => {
  const currentUser = useLoggedInUser();
  const { t } = useResource();

  const userID = currentUser?.userID;

  if (!userID) {
    return <Navigate to={appUrl("sign-in")} replace />;
  }

  if (currentUser.userStatus !== UserStatus.RoleSelection) {
    return <Navigate to={appUrl("dashboard")} />;
  }

  return (
    <OnboardingLayout title={t(COMPONENT_RESOURCES.Title)}>
      <NewUserRoleSelection />
    </OnboardingLayout>
  );
};
